import React from 'react';

const CurentCountBins = (props) => {
  let displayData;
  if (!!props.active){
    return (
        <span>--</span>
    );
  }
  if(props.actives && props.actives.includes(props.row.binName) || props.row.parts.filter(item => props.actives.includes(item.partnum)).length > 0 ){
    displayData = props.row.currentCount
  }else if (props.row.parts.every(b => b.currentCount)) {
    displayData = props.row.currentCount
  } else if (props.row.parts.some(b => b.currentCount)) {
    displayData = props.row.currentCount + '*'
  } else {
    displayData = '--'
  }
  return (
      <span>{displayData}</span>
  );
}

export default CurentCountBins;